module.exports = __webpack_public_path__ + "img/logo_poissonnerie.1050ab7e.png";